export const TOGGLE_DASHBOARD_WIDGET = 'TOGGLE_DASHBOARD_WIDGET'
export const RESET_DASHBOARD_WIDGETS = 'RESET_DASHBOARD_WIDGETS'
